import React from 'react';
import { ProductPriceView } from 'common/components/product-price-view';
import { ProductPriceViewSticky } from '../pdp-sticky-card-panel/components/product-price-view-sticky';
import { APriceViewProps } from './types';

export const APriceView: React.FC<APriceViewProps> = ({
  name,
  className,
  prevPrice,
  isBestPrice,
  hasThreePrices,
  isStickyPanel,
  ...rest
}) => {
  let variant = name === 'second' ? 'second-price' : 'primary-price';
  if (prevPrice) {
    variant = 'old-new-price';
  }

  if (isStickyPanel) {
    return (
      <ProductPriceViewSticky
        hasThreePrices={hasThreePrices}
        className={className}
        slot={variant}
        prevPrice={prevPrice}
        variant={variant}
        isBestPrice={isBestPrice}
        isStickyValue={isStickyPanel}
        {...rest}
      />
    );
  }

  return (
    <ProductPriceView
      className={className}
      slot={variant}
      prevPrice={prevPrice}
      variant={variant}
      isBestPrice={isBestPrice}
      {...rest}
    />
  );
};
